var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18.968,
    viewBox: "0 0 28 18.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__germany",
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_385",
    d: "M0 304v3.7a2.614 2.614 0 0 0 2.71 2.619h22.58A2.614 2.614 0 0 0 28 307.7V304z",
    "data-name": "Path 385",
    transform: "translate(0 -211.355)",
    style: {
      fill: "#f8d12e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_386",
    d: "M25.29 80H2.71A2.614 2.614 0 0 0 0 82.619v3.7h28v-3.7A2.614 2.614 0 0 0 25.29 80z",
    "data-name": "Path 386",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_366",
    d: "M0 0H28V6H0z",
    "data-name": "Rectangle 366",
    transform: "translate(0 86.484)",
    style: {
      fill: "#db2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_387",
    d: "M322.606 310.323a2.692 2.692 0 0 0 2.8-2.619V304H315.2z",
    "data-name": "Path 387",
    transform: "translate(-297.406 -211.355)",
    style: {
      fill: "#dbb30f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_388",
    d: "M70.581 80H48l7.5 6.323h17.79v-3.7A2.614 2.614 0 0 0 70.581 80z",
    "data-name": "Path 388",
    transform: "translate(-45.29)",
    style: {
      fill: "#202121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_389",
    d: "M187.677 198.323h10.161V192H180z",
    "data-name": "Path 389",
    transform: "translate(-169.839 -105.677)",
    style: {
      fill: "#c10e0e"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_390",
    d: "M70.581 80H48l20.91 6.323h4.38v-3.7A2.614 2.614 0 0 0 70.581 80z",
    "data-name": "Path 390",
    transform: "translate(-45.29)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_391",
    d: "M419.006 193.265V192H414.4z",
    "data-name": "Path 391",
    transform: "translate(-391.006 -105.677)",
    style: {
      fill: "#a00808"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_392",
    d: "M28 368.045a2.571 2.571 0 0 1-2.71 2.664H2.71A2.689 2.689 0 0 1 0 368",
    "data-name": "Path 392",
    transform: "translate(0 -271.742)",
    style: {
      fill: "#d89f12"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.d8c080d19540e45a0f935b76e58957d0.svg";
export { ForwardRef as ReactComponent };